module.exports = __webpack_public_path__ + "testimonial-quote-top.png?ecb1345286885f59f6d27b2400c7fd42";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonial-quote-top.png
// module id = 82
// module chunks = 0